"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var HabitatRedo_exports = {};
__export(HabitatRedo_exports, {
  default: () => HabitatRedo_default
});
module.exports = __toCommonJS(HabitatRedo_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.832 4C15.832 3.85677 15.8776 3.73958 15.9688 3.64844C16.0729 3.54427 16.1966 3.49219 16.3398 3.49219C16.4701 3.49219 16.5807 3.54427 16.6719 3.64844C16.776 3.73958 16.8281 3.85677 16.8281 4V7.75C16.8281 7.9974 16.737 8.21224 16.5547 8.39453C16.3854 8.57682 16.1706 8.66797 15.9102 8.66797H12.1602C12.0299 8.66797 11.9128 8.6224 11.8086 8.53125C11.7174 8.42708 11.6719 8.30339 11.6719 8.16016C11.6719 8.02995 11.7174 7.91927 11.8086 7.82812C11.9128 7.72396 12.0299 7.67188 12.1602 7.67188H15.2461C14.7643 6.85156 14.0807 6.1875 13.1953 5.67969C12.3099 5.17188 11.3529 4.91797 10.3242 4.91797C9.54297 4.91797 8.82031 5.0612 8.15625 5.34766C7.47917 5.64714 6.88672 6.05078 6.37891 6.55859C5.87109 7.05339 5.47396 7.63281 5.1875 8.29688C4.90104 8.97396 4.75781 9.69661 4.75781 10.4648C4.75781 11.2201 4.90104 11.9362 5.1875 12.6133C5.47396 13.2904 5.87109 13.8828 6.37891 14.3906C6.88672 14.8854 7.47917 15.276 8.15625 15.5625C8.82031 15.849 9.54297 15.9922 10.3242 15.9922C11.0273 15.9922 11.6979 15.8685 12.3359 15.6211C12.9609 15.3737 13.5208 15.0352 14.0156 14.6055C14.5104 14.1628 14.9141 13.6484 15.2266 13.0625C15.5521 12.4766 15.7539 11.8385 15.832 11.1484C15.8581 11.0182 15.9232 10.9141 16.0273 10.8359C16.1315 10.7448 16.2552 10.7057 16.3984 10.7188C16.5286 10.7318 16.6328 10.7969 16.7109 10.9141C16.8021 11.0182 16.8411 11.1419 16.8281 11.2852C16.724 12.0924 16.4831 12.8411 16.1055 13.5312C15.7279 14.2344 15.2461 14.8464 14.6602 15.3672C14.0872 15.875 13.4297 16.2721 12.6875 16.5586C11.9453 16.8581 11.1576 17.0078 10.3242 17.0078C9.41276 17.0078 8.5599 16.832 7.76562 16.4805C6.97135 16.1419 6.27474 15.6797 5.67578 15.0938C5.07682 14.4948 4.60807 13.7982 4.26953 13.0039C3.91797 12.2096 3.74219 11.3633 3.74219 10.4648C3.74219 9.55339 3.91797 8.70052 4.26953 7.90625C4.60807 7.11198 5.07682 6.42188 5.67578 5.83594C6.27474 5.23698 6.97135 4.76823 7.76562 4.42969C8.5599 4.09115 9.41276 3.92188 10.3242 3.92188C10.8711 3.92188 11.4115 3.98698 11.9453 4.11719C12.4792 4.2474 12.9805 4.4362 13.4492 4.68359C13.931 4.93099 14.3737 5.22396 14.7773 5.5625C15.181 5.91406 15.5326 6.30469 15.832 6.73438V4Z",
      fill: "currentColor"
    }
  )
);
const SvgHabitatRedo = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var HabitatRedo_default = SvgHabitatRedo;
